// extracted by mini-css-extract-plugin
export default {"form":"styles_form__f6+Eq","input":"styles_input__czEXV","buttons":"styles_buttons__-i7pC"};